var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreenerSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.672,
    height: 25.687,
    viewBox: "0 0 25.672 25.687",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "screener-svgrepo-com",
    transform: "translate(-5.011 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23332",
    "data-name": "Path 23332",
    d: "M5.511,24.493v7.455h7.431",
    transform: "translate(0 -6.32)",
    fill: "none",
    stroke: "#642d92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23333",
    "data-name": "Path 23333",
    d: "M31.971,12.906V5.5H24.541",
    transform: "translate(-6.333)",
    fill: "none",
    stroke: "#642d92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23334",
    "data-name": "Path 23334",
    d: "M12.942,5.5H5.511v7.406",
    fill: "none",
    stroke: "#642d92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23335",
    "data-name": "Path 23335",
    d: "M37.955,33.391H33.411v4.56m-4.545-4.56h4.545v-4.56",
    transform: "translate(-7.772 -7.764)",
    fill: "none",
    stroke: "#642d92",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenerSvgrepoCom);
export default __webpack_public_path__ + "static/media/screener-svgrepo-com.c90be562304a37f43f96f7140b02db53.svg";
export { ForwardRef as ReactComponent };